<div class="video-viewer-wrapper">
  <video
    #videoEl
    class="preview-video"
    controls
    playsinline
    loop
    controlsList="nodownload noplaybackrate"
    disablePictureInPicture
    disableRemotePlayback
    preload="metadata"
    [poster]="poster"
  ></video>
</div>
